export enum CookieCategory {
    Essential = 'Essential',
    Performance = 'Performance',
    Functional = 'Functional',
    Advertising = 'Advertising',
}

export const CookieNames = {
    DARK_MODE: 'dark_mode',
};
